import * as React from 'react';
const SvgFluidWorkflow = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fill="#003DE4"
      fillRule="evenodd"
      d="M3.75 2h2.5C7.216 2 8 2.784 8 3.75v2.5A1.75 1.75 0 0 1 6.25 8h-2.5A1.75 1.75 0 0 1 2 6.25v-2.5C2 2.784 2.784 2 3.75 2m0 1.5a.25.25 0 0 0-.25.25v2.5c0 .138.112.25.25.25h2.5a.25.25 0 0 0 .25-.25v-2.5a.25.25 0 0 0-.25-.25zM12 10h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2m0 1.5a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-.5-.5z"
      clipRule="evenodd"
    />
    <path
      fill="#003DE4"
      d="M9 4.25v1.5h3.75a.5.5 0 0 1 .5.5V9h1.5V6.25a2 2 0 0 0-2-2zM9 13.25v1.5H6.25a2 2 0 0 1-2-2V9h1.5v3.75a.5.5 0 0 0 .5.5z"
    />
  </svg>
);
export default SvgFluidWorkflow;
